import { TextBlock } from 'gojs';

// https://forum.nwoods.com/t/check-that-text-is-overflowed/9481/5
export const objectHasElipsis = (obj: TextBlock): boolean => {
  // we need to cast cause there is no typing go.TextBlock.metrics
  const objWithMetrics = obj as unknown as { metrics?: { arrText?: string[] } };

  const arrText = objWithMetrics?.metrics?.arrText;
  const ELLIPSIS = '...';
  return !!arrText?.at(-1)?.includes(ELLIPSIS);
};
